define('views/modules/note/note-edit-modal',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'services/i18n',
    //models
    'models/note/note',
    // views
    'views/parts/modal/modal',
    'views/parts/form/chatbox',
    // templates
    'text!templates/modules/note/note-edit-modal.html',

], function(
    // Libs
    _, Backbone, Mustache, U, i18n,
    //models
    MNote,
    // views
    VModal,
    VChatbox,
    //templates
    TNoteEditModal

) {
    var VNoteEditModal = VModal.extend({
        template: TNoteEditModal,
        regions: {
            chatbox: '.note-edit-chatbox'
        },

        modal: function() {
            return { title: i18n.t("Edit Note") };
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            _.extend(this, {
                group: opt.group,
                profile: opt.profile
            });

            var model = this.model = new MNote(),
                view = this.view = {
                    chatbox: new VChatbox({
                        button: false,
                        attribute: 'text',
                        model: model,
                        context: this
                    })
                };

            this.listenTo(view.chatbox, {
                "file:change": this.onFileChange,
                "file:remove": this.onFileRemove,
            });
        },
        render: function() {
            var html = Mustache.render(this.template),
                chatbox = this.view.chatbox,
                model = this.model;
            this.$el.empty().append(html);
            this.generateZones()
                .assign(chatbox, this.zone.$chatbox);

            if (model.has('attachment')) {
                chatbox.setFileName(model.get('attachment').name);
            }

            this.renderModal();

            return this;
        },
        show: function(model) {
            this.modelMaster = model;
            this.model.reset(model.attributes);
            this.render();
        },

        ////////////
        // events //
        ////////////
        onFileChange: function(file, view) {
            this.model.setAttachment(file);
        },
        onFileRemove: function(oldFile, view) {
            this.model.setAttachment();
        },
        onConfirm: function(confirmed) {
            var model = this.model,
                options = this.options;
            if (confirmed) {
                model.set('text', this.view.chatbox.getValue());
                var master = this.modelMaster,
                    changes = master.changedAttributes(model.attributes);

                master.setGroup(this.group.id);
                master.setUser(this.profile.id);

                if (changes !== false) {
                    master.save(changes, {
                        patch: true,
                        success: options.callback,
                        context: options.context
                    });
                }

            }
            model.reset();
        }
    });

    return VNoteEditModal;
});

